jQuery( function($) {
  window.social = {}

  window.social.gtag = function() {
    let $this = $(this)
    gtag( 'event', 'Share Recipe', {
      'event_category': $this.data('event-category'),
      'event_label': $this.data('event-label')
    })
  }

  window.social.eventListeners = function() {
    $('.social-media a').on( 'click', window.social.gtag )
  }

  $(window).on( 'load', window.social.eventListeners )
})


// WEBPACK FOOTER //
// ./src/js/social.js